/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_AloneInputs */

const th_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีใครเข้าร่วม เมื่อมีคนเข้ามาจะแสดงที่นี่`)
};

const en_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody else has joined yet. They appear here when they do.`)
};

const ja_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ誰も参加していません。参加するとここに表示されます。`)
};

const zh_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前还没有别人。有人加入时会显示在这里。`)
};

const es_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no se ha unido nadie más. Aparecerán aquí cuando lo hagan.`)
};

const pt_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguém mais entrou ainda. Aparecem aqui quando entrarem.`)
};

const id_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada orang lain di sini. Mereka akan muncul saat bergabung.`)
};

const fr_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personne d’autre n’a encore rejoint. Ils apparaîtront ici.`)
};

const tl_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang ibang narito. Lilitaw sila pagdating nila.`)
};

const vi_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có ai khác ở đây. Họ sẽ hiện lên khi vào.`)
};

const ko_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 아무도 없습니다. 들어오면 여기에 나타납니다.`)
};

const de_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist noch niemand sonst da. Sie erscheinen hier, sobald sie kommen.`)
};

const ru_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здесь пока никого нет. Они появятся, когда подключатся.`)
};

const tr_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz başka kimse yok. Katıldıklarında burada görünürler.`)
};

const it_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non c'è ancora nessun altro. Compariranno quando entrano.`)
};

const pl_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma tu jeszcze nikogo innego. Pojawią się, gdy dołączą.`)
};

const uk_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тут поки нікого немає. Вони з'являться, коли приєднаються.`)
};

const hi_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी यहाँ कोई और नहीं है। वे शामिल होते ही दिखेंगे।`)
};

const ar_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا أحد آخر هنا بعد. سيظهرون حين ينضمّون.`)
};

const ms_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada orang lain di sini. Mereka akan muncul apabila menyertai.`)
};

const bn_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও আর কেউ নেই। যোগ দিলে তাঁরা দেখা যাবেন।`)
};

const zh_tw2_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前還沒有其他人。有人加入時會顯示在這裡。`)
};

const zh_hk2_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前還沒有其他人。有人加入時會顯示在這裡。`)
};

const ur_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی اور نہیں ہے۔ شامل ہونے پر وہ یہاں دکھائی دیں گے۔`)
};

const fa_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز کس دیگری اینجا نیست. با پیوستن، اینجا دیده می‌شوند.`)
};

const sw_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bado hakuna mtu mwingine hapa. Wataonekana watakapojiunga.`)
};

const nl_meeting_alone = /** @type {(inputs: Meeting_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is nog niemand anders. Ze verschijnen zodra ze binnenkomen.`)
};

/**
* | output |
* | --- |
* | "Nobody else has joined yet. They appear here when they do." |
*
* @param {Meeting_AloneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_alone = /** @type {((inputs?: Meeting_AloneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_AloneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_alone(inputs)
	if (locale === "ja") return ja_meeting_alone(inputs)
	if (locale === "zh") return zh_meeting_alone(inputs)
	if (locale === "es") return es_meeting_alone(inputs)
	if (locale === "pt") return pt_meeting_alone(inputs)
	if (locale === "id") return id_meeting_alone(inputs)
	if (locale === "fr") return fr_meeting_alone(inputs)
	if (locale === "tl") return tl_meeting_alone(inputs)
	if (locale === "vi") return vi_meeting_alone(inputs)
	if (locale === "ko") return ko_meeting_alone(inputs)
	if (locale === "de") return de_meeting_alone(inputs)
	if (locale === "ru") return ru_meeting_alone(inputs)
	if (locale === "tr") return tr_meeting_alone(inputs)
	if (locale === "it") return it_meeting_alone(inputs)
	if (locale === "pl") return pl_meeting_alone(inputs)
	if (locale === "uk") return uk_meeting_alone(inputs)
	if (locale === "hi") return hi_meeting_alone(inputs)
	if (locale === "ar") return ar_meeting_alone(inputs)
	if (locale === "ms") return ms_meeting_alone(inputs)
	if (locale === "bn") return bn_meeting_alone(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_alone(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_alone(inputs)
	if (locale === "ur") return ur_meeting_alone(inputs)
	if (locale === "fa") return fa_meeting_alone(inputs)
	if (locale === "sw") return sw_meeting_alone(inputs)
	if (locale === "nl") return nl_meeting_alone(inputs)
	return en_meeting_alone(inputs)
});